export function shortenErrorMsg(msg) {
    if (!msg)
        return "Try again later";
    const withoutBodyPreview = msg.split(" bodyPreview=")[0];
    return withoutBodyPreview.length > 220
        ? withoutBodyPreview.slice(0, 220) + "..."
        : withoutBodyPreview;
}
